import { useRouteMatch } from 'react-router-dom';
import { useMedia } from '@qover/hooks';
import { STEPS, MOBILE_STEPS } from '../utils/teslaConstants';
import Step from '../domain/Step';

const getSteps = (steps: Step[], path?: string) => {
  const stepIndex = steps.findIndex(step =>
    step.paths.find(p => p.path === path),
  );
  const completionPercentage = (stepIndex / steps.length) * 100;

  return {
    currentStep: steps[stepIndex]?.paths.find(p => p.path === path),
    completionPercentage,
    steps,
  };
};

export function useSteps() {
  const isMobile = useMedia(['(max-width: 767px)'], [true], false);
  const prefixMatch = useRouteMatch().url;
  const match = useRouteMatch<{ stepPath: string }>(`${prefixMatch}/:stepPath`);
  const { stepPath } = match?.params ?? {};

  return getSteps(isMobile ? MOBILE_STEPS : STEPS, stepPath);
}
